<template>
  <div class="bind-phone-page">
    <div class="page-header">
      <div class="back-btn" @click="goBack">
        <i class="el-icon-arrow-left"></i>
      </div>
      <h1>Bind Phone Number</h1>
      <div class="support-btn">
        <!-- <i class="el-icon-service"></i> -->
      </div>
    </div>

    <div class="page-content">
      <BindPhone 
        :fromPage="fromPage" 
        @bindDone="handleBindDone"
      />
    </div>
    <!-- <button @click="handleBindDone">直接成功</button> -->
  </div>
</template>

<script>
import BindPhone from '@/components/BindPhone.vue';

export default {
  name: 'BindPhonePage',
  components: {
    BindPhone
  },
  data() {
    return {
      fromPage: null
    }
  },
  created() {
    this.fromPage = this.$route.query.from || 'login';
  },
  methods: {
    goBack() {
      // 用户直接返回，传递 false 表示未完成绑定
      this.$router.go(-1);
    },
    
    handleBindDone() {
      if (this.fromPage === 'checkout') {
          // 从checkout来的，返回checkout页面
          this.$router.push('/checkout');
        } else {
        // 如果没有指定跳转路径，返回上一页或首页
        if (window.history.length > 2) {
          this.$router.go(-1);
        } else {
          this.$router.replace('/');
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.bind-phone-page {
  min-height: 100vh;
  background: #f8f9fa;

  .page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    background: #fff;
    border-bottom: 1px solid #e9ecef;

    .back-btn {
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-radius: 8px;
      transition: background-color 0.3s ease;

      &:hover {
        background: #f8f9fa;
      }

      i {
        font-size: 20px;
        color: #333;
      }
    }

    h1 {
      font-size: 16px;
      font-weight: 600;
      color: #2c3e50;
      margin: 0;
    }

    .support-btn {
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-radius: 8px;
      transition: background-color 0.3s ease;

      &:hover {
        background: #f8f9fa;
      }

      i {
        font-size: 18px;
        color: #ab1ec4;
      }
    }
  }

  .page-content {
    padding: 20px 0;
  }
}

// 移动端适配
@media (max-width: 480px) {
  .bind-phone-page {
    .page-header {
      padding: 12px 16px;

      h1 {
        font-size: 14px;
      }

      .back-btn,
      .support-btn {
        width: 36px;
        height: 36px;

        i {
          font-size: 18px;
        }
      }
    }

    .page-content {
      padding: 16px 0;
    }
  }
}
</style>
